<app-base-uploader
  [size]="size"
  [label]="label"
  [uploadLabel]="'common.file.uploadVideo' | transloco"
  [isDisabled]="isDisabled"
  [isRequired]="isRequired"
  [isClearable]="isClearable"
  [value]="value"
  [isValueExist]="!!value?.videoUrl"
  (clear)="onClear()"
  (upload)="onUpload()">
  <video
    *ngIf="value?.videoUrl"
    #videoPlayer
    ngProjectAs="image"
    class="uploader-media"
    [src]="value.videoUrl"
    [poster]="value.thumbnailUrl"
    (loadeddata)="onVideoPlayerLoad()"
    autoplay
    loop
    muted>
  </video>
</app-base-uploader>
